import { useState } from "react";
import { Flex } from "@chakra-ui/react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Spinner } from "react-bootstrap";
// import placeholder from "../../assets/images/placeholder.png";
const CarouselImage = ({ src, placeholder, errorImage, alt }) => {
  const [imageSrc, setImageSrc] = useState(placeholder);
  const [isLoading, setIsLoading] = useState(true);

  // const handleLoad = () => {
  //   setIsLoading(true); // Replace with actual image once loaded
  //   setIsLoading(false); // Replace with actual image once loaded
  // };

  return (
    <Flex justifyContent={"center"} alignItems={"center"} maxH={"45em"}>
      {/* {isLoading ? (
        <Flex h={"50vh"} justify={"center"} align={"center"}>
          <Spinner animation="grow" />
        </Flex>
      ) : ( */}
      <LazyLoadImage
        // placeholderSrc={placeholder}
        effect="blur"
        className="image"
        src={src}
        alt={alt}
        style={{ margin: 0 }}
        // style={{ objectFit: "cover", maxWidth: "100%", maxHeight: "100%" }}
      />
      {/* )} */}
    </Flex>
  );
};

export default CarouselImage;
